import {TimelineLite} from "gsap";
import { manager } from './../app';

class MenuManager {

    constructor() {
        this.tl = null;
        this.isOpen = false;
        this.onCloseCallback = undefined;
        this.menuToggle = document.querySelector('.menu-toggle');
        this.hamburger = this.menuToggle;
        this.menuWrapper = document.querySelector('.menu-wrapper');
        this.timeline();
    }

    static setup() {
        let self = new MenuManager();
        self.menuToggle.addEventListener( 'click', self.trigger.bind(self) );
        return self;
    }

    trigger(e) {
        e.preventDefault();

        if (this.menuWrapper.classList.contains('closed')) return this.open();

        return this.close();
    }

    open() {
        if( manager ) {
            return manager.lastTransition.onReverseComplete( this.openingAnimation, this ).reverse()
        }
        this.openingAnimation()
    }

    openingAnimation() {
        this.hamburger.classList.add('open');
        this.isOpen = true;
        this.menuWrapper.classList.remove('closed');
        this.tl.play();
    }

    close() {
        let _this = this;
        this.tl.eventCallback('onReverseComplete', () => {
            _this.isOpen = false;
            _this.hamburger.classList.remove('open');
            _this.menuWrapper.classList.add('closed');

            if( manager ) {
                manager.lastTransition.play();

                if (_this.onCloseCallback !== undefined) {
                    _this.onCloseCallback();
                }

                _this.onCloseCallback = undefined;
            }
        });
        this.tl.reverse();
    }

    onClose( callback ) {
        this.onCloseCallback = callback;
    }

    timeline() {
        this.tl = new TimelineLite({
            paused: true,
        })
            .to('.menu-wrapper', .35, {backgroundColor: 'rgba(255, 255, 255, 1)'}, 0)
            .from('.menu-wrapper nav.main-menu', .5, {height: 0}, 0)
            .addLabel('menuOpen')
            .staggerFrom('.menu-wrapper nav.main-menu li', .15, {
                opacity: 0,
                y: -15
            }, .05, 'menuOpen')
            .from('.menu-wrapper address.contact-area', .35, {
                opacity: 0,
                x: -15
            }, 'menuOpen');
    }

}

export default MenuManager;